<template>
  <el-drawer
    title="技术资料库"
    :modal="false"
    :visible.sync="visible"
    size="400px"
    @close="$emit('update:show', false)"
    @open="hanldeOpen"
  >
    <div style="padding: 0px 20px 20px 20px">
      <el-collapse accordion>
        <el-collapse-item
          :title="wiki.title"
          v-for="wiki in lists"
          :key="wiki.id"
        >
          <div class="">
            <div class="font-12 text-gray">
              更新于：{{ $time(wiki.updated_at).format('YYYY/MM/DD HH:mm') }}
            </div>
            <!-- <div class="mt-5">
              <el-tag
                type="info"
                size="mini"
                v-for="item in wiki.item_category_names"
                :key="item"
                >{{ item.replace(/,/g, '-') }}</el-tag
              >
            </div> -->
            <div v-if="wiki.content_type == 1" class="content">
              <el-link
                :href="wiki.content"
                type="primary"
                class="font-12"
                target="_blank"
                :underline="false"
                >查看详情</el-link
              >
            </div>
            <div v-else class="mt-20 content" v-html="wiki.content"></div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div
        v-if="!loading && lists.length == 0"
        class="text-center text-gray font-12"
        style="margin-top: 50px"
      >
        暂无资料
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { wikiList } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      visible: this.show,
      lists: [],
      loading: true,
    }
  },
  methods: {
    async hanldeOpen() {
      this.loading = true
      let data = {
        page: 0,
        size: 100,
        customer_device_id: this.model.customer_device_id,
      }
      let res = await wikiList(data)

      if (res.code == 0) {
        this.lists = res.data.list
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.content {
  word-break: break-all;
}

/deep/.content p {
  margin-bottom: 0;
}

/deep/.content img {
  max-width: 100%;
}
</style>